export default __webpack_public_path__ + "locales/ko-KR/Translations.json?hash=2d1db8665be5e922a761319915cd3ebe";